import { takeUntil } from 'rxjs/operators';
import { OwnListService } from './../own-list.service';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { Global } from "../classes/Global";
import { UrlValidator } from "../helpers/UrlValidater";
import { OffersService } from "../offers.service";
import { GenresService } from "../genres.service";
import { OffersParentComponent } from '../classes/OffersParentComponent';
import { InfoService } from '../info.service';
import { WishlistService } from '../wishlist.service';
import { AuthenticationService } from '../authentication.service';
import { SettingsService } from '../settings.service';
import { ThemeService } from '../theme.service';
import { StringHelper } from '../helpers/StringHelper';
import { Subject } from 'rxjs';
import { SeoService } from '../seo.service';
import { Config } from '../classes/Config';
import { StorageHelper } from '../helpers/StorageHelper';
import { CustomMap } from '../multipick-dropdown/multipick-dropdown.component';
import { BlocklistService } from '../blocklist.service';
import { AiStructuredDataHelper } from '../helpers/AiStructuredDataHelper';

@Component({
  selector: 'app-on-sale',
  templateUrl: './on-sale.component.html',
  styleUrls: ['./on-sale.component.scss'],
  providers: [ OffersService, GenresService, InfoService,
    WishlistService, AuthenticationService, OwnListService ]
})
export class OnSaleComponent extends OffersParentComponent implements OnInit, AfterViewInit {

  isDescriptionExpanded = false;
  schema;
  @ViewChild('movieRatingsDD', {static: false}) movieRatingsDD;
  @ViewChild('movieRatingsSliders', {static: false}) movieRatingsSliders;

  constructor(
    private offersService: OffersService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected genresService: GenresService,
    protected infoService: InfoService,
    protected wishlistService: WishlistService,
    protected blocklistService: BlocklistService,
    protected authenticationService: AuthenticationService,
    protected ownlistService: OwnListService,
    protected settingsService: SettingsService,
    protected themeService: ThemeService,
    protected seoService: SeoService
  ) {
    super(genresService, router, route, authenticationService, infoService, wishlistService, blocklistService, ownlistService, settingsService, themeService, seoService);
    this.identifier = "on-sale";
  }

  toggleDescription() {
    this.isDescriptionExpanded = !this.isDescriptionExpanded;
  }

  initSorting() {
    this.sortValues = this.getSortingValues();
    this.sortPeriodValues = this.getSortPeriodValues();

    if (this.sortValues.indexOf(this.getSort(this.listType)) > -1) {
      this.sortKey = this.getSort(this.listType);
    }
    else {
      this.sortKey = this.sortValues[0];
      StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.sort, this.sortKey);
    }

    if(this.sortPeriodValues.indexOf(this.getSortPeriod()) > -1) {
      this.sortPeriodKey = this.getSortPeriod();
    }
    else {
      this.sortPeriodKey = this.sortPeriodValues[0];
      StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.sortPeriod, this.sortPeriodKey);
    }
  }

  getDefaultSortValue() {
    if (this.listType == Global.CHARTS || /* this.listType == Global.TOP_200 || */ this.listType == Global.COMING_SOON) {
      return 'rank';
    }
    return this.sortValues? this.sortValues[0] : "";
  }

  ngOnInit() {
    UrlValidator.validateUrl(this.route, this.router, 'on-sale', this);
    this.getSessionTokenFromUrl();
    this.getListTypeParameter();
    this.buildGptApiSchema();
    super.onInit();
    this.readQueryParams().then(() => {
      this.loadGenreAndItems();
    });
  }

  showSortPeriodNewFeatureBubble() {
    return StorageHelper.getInstance().get(StorageHelper.keys.showSortPeriodNewFeatureBubble) == "false"? false : true;
  }

  showHideFrenchTitlesNewFeaturePopup() {
    const storageHelper = StorageHelper.getInstance();
    const mediaType = Global.getMediaType();
    const isMovieMediaType = mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES;

    return storageHelper.get(StorageHelper.keys.showHideFrenchTitlesNewFeaturePopup) != "false" &&
      !!storageHelper.get(StorageHelper.keys.sessionToken) &&
      Global.getCountry() === Global.countries.ca.key &&
      Global.getStore() === Global.ITUNES &&
      this.listType === Global.ON_SALE &&
      this.selectedMediaType === 'movies' &&
      isMovieMediaType;
  }

  getStore(): string {
    return Global.getStore();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setScrollPosition();
    });
  }

  readQueryParams(): Promise<void> {

    return new Promise((resolve, reject) => {

      //Notifier
      const ngUnsubscribe: Subject<any> = new Subject();

      this.route.queryParams.pipe(takeUntil(ngUnsubscribe.asObservable())) //take values until a notifier emits a value
      .subscribe(queryParams => {

        const studioParam = queryParams['studio'];
        if(studioParam) {

          const studios: CustomMap[] = Config.studios.map(x => {
            if(x.id) {
              return { key: x.id, value: x.title };
            }
            else {
              return { key: x, value: x }
            }
          });
          const studio = studios.filter(x => x.key == studioParam)[0];
          if(studio) {
            this.selectedStudioOptions = [studio];
            StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), this.listType, StorageHelper.keys.studio, this.selectedStudioOptions);
          }

        }

        //notifies that params have been received and route.params can be unsubscribed
        ngUnsubscribe.next();
        ngUnsubscribe.complete();

        resolve();

      });

    });

  }

  showAmazonUSItems(): boolean {
    if(Global.getCountry() == "us" && Global.getStore() == Global.AMAZON && !Config.showAmazonUS) {
      return false;
    }
    return true;
  }

  //Convert mediaTypes and listTypes into string keys to display them
  getString(key: string): string
  {
    const mediaType = Global.getMediaType();

    switch (key){
      case Global.BUYMOVIES:
      case Global.RENTALMOVIES:
        key = "movies";
        break;
      case Global.ALBUMS:
      case Global.SINGLES:
        key = "music";
        break;
      case "pricefilter":
        key = "priceFilter";
        break;
      case Global.IMDBTOP250:
        key = "imdbTop250";
        break;
      case Global.BUNDLES:
        key = (mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES) ? "movieBundles" : "tvBundles";
        break;
      case Global.MOVIES_4K:
        key = "movies4K";
        break;
      case Global.MOVIES_3D:
        key = "movies3D";
        break;
      case Global.AZ:
        switch (mediaType){
          case Global.BUYMOVIES:
          case Global.RENTALMOVIES:
            key = "allMovies";
            break;
          case Global.SEASONS:
            key = "allSeasons";
            break;
          case Global.ALBUMS:
            key = "allMusic";
            break;
          case Global.APPS:
            key = "allApps";
            break;
          case Global.MACAPPS:
            key = "allMacApps";
            break;
          case Global.EBOOKS:
            key = "allEbooks";
            break;
          case Global.AUDIOBOOKS:
            key = "allAudiobooks";
            break;
        }
        break;
      case Global.PREORDER:
        key = "preorder";
        break;
      case "recentlyadded":
        key = (mediaType == "macapps") ? "newInMacAppStore" : (mediaType == "apps") ? "newInAppStore" : "newOniTunes";
        break;
      case Global.NOW_FREE:
        key = "currentlyForFree";
        break;
      case Global.NEW_ON_PRIME_VIDEO:
        key = "newOnPrimeVideo";
        break;
      case Global.VISION_PRO_APPS:
        key = "vision-pro-apps";
        break;
      case Global.GREATESTHITS:
        key = "greatestHits";
        break;
      case Global.UPGRADED_4K:
        key = "upgradedTo4K";
        break;
      default:
        break;
    }
    return super.getString(key);
  }

  getOffers() {

    let selectedDevice = this.selectedDevice? this.selectedDevice["type"] : this.getDevices()[0]["type"];
    let selectedSoundOption = this.selectedSoundOption ? this.selectedSoundOption["type"] : this.getSoundOptions()[0]["type"];
    let selectedMAOption = this.selectedMAOption ? this.selectedMAOption["type"] : this.getMoviesAnywhereOptions()[0]["type"];
    let selectedAudiotrack = this.selectedAudiotrackOption ? this.selectedAudiotrackOption["type"] : this.getAudiotrackOptions()[0]["type"];
    let selectedItunesExtrasOption = this.selectedItunesExtrasOption ? this.selectedItunesExtrasOption["type"] : this.getItunesExtrasOptions()[0]["type"];
    let selectedOffersFilterOption = this.selectedOffersFilterOption ? this.selectedOffersFilterOption['type'] : this.getOfferFilterOptions()[0]['type'];
    let selectedBundleFilterOption = this.selectedBundleFilterOption ? this.selectedBundleFilterOption['type'] : this.getBundleFilterOptions()[0]['type'];
    let selectedFrenchTitlesOption = this.selectedFrenchTitlesOption ? this.selectedFrenchTitlesOption['type'] : this.getFrenchTitlesOptions()[0]['type'];

    return this.offersService.getOffers(Global.getStore(), this.listType, Global.getCountry(),
    this.getMediaTypeForGetOffers(), this.formatMultiSelectionForServer(this.selectedGenres, this.genres),
    this.getQuality(), this.getSortForServer(), this.offset, this.limit, selectedDevice,
    this.getPriceTypeForServer(),
    this.formatMultiSelectionForServer(this.selectedAdvisoryRatings, this.advisoryRatings),
    selectedSoundOption, selectedMAOption,
    this.formatMultiSelectionForServer(this.selectedHdrFormatOptions, this.hdrFormatOptions),
    this.movieRatingsFilters, this.formatMultiSelectionForServer(this.selectedStudioOptions,
      this.studioOptions), this.formatMultiSelectionForServer(this.selectedPriceRanges, this.priceRanges),
      selectedAudiotrack, selectedItunesExtrasOption, selectedOffersFilterOption, this.selectedReleaseYear, this.sortPeriodKey,
      selectedBundleFilterOption, this.selectedRuntime, selectedFrenchTitlesOption,
      this.formatMultiSelectionForServer(this.selectedPricePerMovieRanges, this.pricePerMovieRanges));
  }

  getSortForServer() {
    if (this.sortKey == Global.PRICE_PER_MOVIE || this.sortKey == Global.PRICE_PER_SEASON) {
      return Global.PRICE_PER_ITEM;
    }
    else {
      return this.sortKey;
    }
  }

  getListTypeParameter() {
    //Notifier
    const ngUnsubscribe: Subject<any> = new Subject();

    //Get the additional listType parameter
    this.route.params.pipe(takeUntil(ngUnsubscribe)).subscribe(params => {
      this.listType = params['listType'] || Global.getListType();

      //notifies that params have been received and route.params can be unsubscribed
      ngUnsubscribe.next();
      ngUnsubscribe.complete();
    });
  }

  reload(newUrl: boolean = false, replaceUrl?: boolean) {
    let mediaType = Global.getMediaType();
    if(mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES) {
      mediaType = Global.MOVIES;
    }
    if(mediaType == Global.ALBUMS || mediaType == Global.SINGLES) {
      mediaType = Global.MUSIC;
    }
    let lT = this.listType;
    if(lT == Global.ON_SALE) {
      lT = this.getString('onSaleUrl');
    }
    else if(lT == Global.CHARTS) {
      lT = "charts";
    }
    // else if (lT == Global.TOP_200) { // Temporarily disabled
    //   lT = "top-200";
    // }
    else if (lT == Global.COMING_SOON) {
      lT = "coming-soon";
    }
    else if(lT == Global.AZ) {
      if(mediaType == Global.MOVIES) {
        lT = this.getString('allMoviesUrl');
      }
      else if(mediaType == Global.SEASONS) {
        lT = this.getString('allSeasonsUrl');
      }
      else if(mediaType == Global.MUSIC) {
        lT = this.getString('allMusicUrl');
      }
      else if(mediaType == Global.EBOOKS) {
        lT = this.getString('allBooksUrl');
      }
      else if(mediaType == Global.AUDIOBOOKS) {
        lT = this.getString('allAudiobooksUrl');
      }
      else if(mediaType == Global.APPS) {
        lT = this.getString('allAppsUrl');
      }
      else if(mediaType == Global.MACAPPS) {
        lT = this.getString('allMacAppsUrl');
      }
    }
    else if(lT == Global.MOVIES_4K) {
      lT = this.getString('movie4kUrl');
    }
    else if(lT == Global.UPGRADED_4K) {
      lT = this.getString('upgradedTo4kUrl');
    }
    else if (lT == Global.MOVIES_3D) {
      lT = this.getString('movie3dUrl');
    }
    else if(lT == Global.BUNDLES) {
      if(mediaType == Global.MOVIES) {
        lT = this.getString('movieBundlesUrl');
      }
      else if(mediaType == Global.SEASONS) {
        lT = this.getString('seasonsBundlesUrl');
      }
    }
    else if(lT == Global.IMDBTOP250) {
      lT = "imdb-top-250";
    }
    else if(lT == Global.PREORDER) {
      lT = this.getString('preorderUrl');
    }
    else if(lT == Global.JUST_RELEASED) {
      lT = this.getString('justReleasedUrl');
    }
    else if (lT === Global.NEW_ON_PRIME_VIDEO) {
      lT = this.getString('newOnPrimeVideoUrl');
    }
    else if(lT == Global.RECENTLYADDED) {
      lT = this.getString('newOniTunesUrl');
    }
    else if(lT == Global.NOW_FREE) {
      lT = this.getString('nowFreeUrl');
    }
    else if(lT == Global.GREATESTHITS) {
      lT = "greatest-hits";
    }
    else if(lT == Global.BLACK_FRIDAY) {
      lT = this.getString('blackFridayDealsUrl');
    }
    const url = Global.getCountry() + "/" + Global.getStoreUrl() + "/" + this.getString(mediaType + "Url") + '/' + lT;
    //if we navigate to this new url while we are on /on-sale for example,
    //it kind of breaks the filters because they closewhen we select something
    //because the url changes. so we don't want to navigate to the new url if we are on these kind of special urls
    if (newUrl || this.router.url.includes(Global.getStoreUrl())) {
      const targetUrl = "/" + url;
      // Only navigate if URL actually changed to prevent excessive replaceState calls
      if (this.router.url !== targetUrl) {
        if (replaceUrl == true) {
          this.router.navigate([url], { replaceUrl: true });
        }
        else {
          this.router.navigate([url]);
        }
      }
    }
    this.buildGptApiSchema("/" + url);
    this.loadGenreAndItems("/" + url);
  }

  buildGptApiSchema(url?: string) {
    const mediaType = Global.getMediaType();
    if (mediaType != Global.BUYMOVIES && mediaType != Global.SEASONS) {
      this.schema = null;
      return;
    }

    this.schema = AiStructuredDataHelper.buildDealsPageSchema(
      this.getHeaderTitle(),
      "https://www.cheapcharts.com" + (url ? url : this.router.url),
      Global.getCountry(),
      Global.getStore(),
      mediaType,
      this.getQuality()
    );
  }

  getSortingValues() {
    return Global.getSortingValues(this.listType);
  }

  getSortPeriodValues() {
    return Global.getSortPeriodValues();
  }

  getHeaderTitle(): string {
    return this.getTextForListType("HeaderTitle");
  }

  getHeaderText() {
    return this.getTextForListType("HeaderText");
  }

  setSpecialSEO(): void {
    super.setSpecialSEO();
    this.getTextForListType("SEO");
  }

  getTextForListType(textType: string): string {

    const mediaType = Global.getMediaType();
    const mediaTypeUpper = mediaType.charAt(0).toUpperCase() + mediaType.slice(1);
    const store = Global.getStore();
    const storeUpper = store.charAt(0).toUpperCase() + store.slice(1);

    const langSuffix = Global.getStoreAndMediaTypeForLangFileSuffix(store, mediaType);

    if (this.listType == Global.ON_SALE) {

      if (textType == "HeaderTitle") return this.getString('onSaleHeaderTitle' + langSuffix);
      if (textType == "HeaderText") return this.getString('onSaleHeaderText' + langSuffix);
      if (textType == "SEO") {
        this.seoService.setTitle(this.getString('onSaleHeaderTitle' + langSuffix));
        this.seoService.setMetaDescription(this.getString('onSaleHeaderText' + langSuffix));
        return;
      }
      //Wenn ein Link drin ist, muss man es so setzen.
      //document.getElementById("headerText").innerHTML = txt;
    }

    if (this.listType == Global.CHARTS) {
      if (textType == "HeaderTitle") return this.getString('chartsHeaderTitle' + langSuffix);
      if (textType == "HeaderText") return this.getString('chartsHeaderText' + langSuffix);
      if (textType == "SEO") {
        this.seoService.setTitle(this.getString('onSaleHeaderTitle' + langSuffix));
        this.seoService.setMetaDescription(this.getString('chartsHeaderText' + langSuffix));
        return;
      }
    }

    // if (this.listType == Global.TOP_200) { // Temporarily disabled
    //   if (textType == "HeaderTitle") return this.getString('top200Title' + langSuffix);
    //   if (textType == "HeaderText") return this.getString('top200Desc' + langSuffix);
    //   if (textType == "SEO") {
    //     this.seoService.setTitle(this.getString('top200Title' + langSuffix));
    //     this.seoService.setMetaDescription(this.getString('top200Desc' + langSuffix));
    //     return;
    //   }
    // }

    if (this.listType == Global.COMING_SOON) {
      if (textType == "HeaderTitle") return this.getString('comingSoonTitle' + langSuffix);
      if (textType == "HeaderText") return this.getString('comingSoonTitle' + langSuffix);
      if (textType == "SEO") {
        this.seoService.setTitle(this.getString('comingSoonTitle' + langSuffix));
        this.seoService.setMetaDescription(this.getString('comingSoonDesc' + langSuffix));
        return;
      }
    }

    if (this.listType == Global.NEW_RELEASES) {
      if (textType == "HeaderTitle") return this.getString('newReleasesTitle' + langSuffix);
      if (textType == "HeaderText") return this.getString('newReleasesTitle' + langSuffix);
      if (textType == "SEO") {
        this.seoService.setTitle(this.getString('newReleasesTitle' + langSuffix));
        this.seoService.setMetaDescription(this.getString('newReleasesDesc' + langSuffix));
        return;
      }
    }

    if (this.listType === Global.NEW_ON_PRIME_VIDEO) {
      if (textType === "HeaderTitle") {
        return this.getString('newOnPrimeVideoTitle');
      }
      if (textType === "HeaderText") {
        return this.getString('newOnPrimeVideoDesc');
      }
      if (textType === "SEO") {
        this.seoService.setTitle(this.getString('newOnPrimeVideoTitle'));
        this.seoService.setMetaDescription(this.getString('newOnPrimeVideoDesc'));
        return;
      }
    }

    if (this.listType == Global.AZ) {
      if (textType == "HeaderTitle") return this.getString('allHeaderTitle' + langSuffix);
      if (textType == "HeaderText") return this.getString('allHeaderText' + langSuffix);
      if (textType == "SEO") {
        this.seoService.setTitle(this.getString('allHeaderTitle' + langSuffix));
        this.seoService.setMetaDescription(this.getString('allHeaderText' + langSuffix));
        return;
      }
    }

    if (this.listType == Global.MOVIES_4K) {
      if (textType == "HeaderTitle") return this.getString('movies4kHeaderTitle');
      if (textType == "HeaderText") return this.getString('movies4kHeaderText');
      if (textType == "SEO") {
        this.seoService.setTitle(this.getString('movies4kHeaderTitle'));
        this.seoService.setMetaDescription(this.getString('movies4kHeaderText'));
        return;
      }
    }

    if (this.listType == Global.UPGRADED_4K) {
      if (textType == "HeaderTitle") return this.getString('upgraded4kHeaderTitle');
      if (textType == "HeaderText") return this.getString('upgraded4kHeaderText');
      if (textType == "SEO") {
        this.seoService.setTitle(this.getString('upgraded4kHeaderTitle'));
        this.seoService.setMetaDescription(this.getString('upgraded4kHeaderText'));
        return;
      }
    }

    if (this.listType == Global.MOVIES_3D) {
      if (textType == "HeaderTitle") return this.getString('movies3dHeaderTitle');
      if (textType == "HeaderText") return this.getString('movies3dHeaderText');
      if (textType == "SEO") {
        this.seoService.setTitle(this.getString('movies3dHeaderTitle'));
        this.seoService.setMetaDescription(this.getString('movies3dHeaderText'));
        return;
      }
    }

    if (this.listType == Global.BUNDLES) {
      if (Global.MOVIES == Global.getMediaTypeForSelector(mediaType)) {
        if (textType == "HeaderTitle") return this.getString('movieBundlesHeaderTitle' + langSuffix);
        if (textType == "HeaderText") return this.getString('movieBundlesHeaderText' + langSuffix);
        if (textType == "SEO") {
          this.seoService.setTitle(this.getString('movieBundlesHeaderTitle' + langSuffix));
          this.seoService.setMetaDescription(this.getString('movieBundlesHeaderText' + langSuffix));
          return;
        }
      }
      if (Global.SEASONS == mediaType) {
        if (textType == "HeaderTitle") return this.getString('seasonBundlesHeaderTitle' + langSuffix);
        if (textType == "HeaderText") return this.getString('seasonBundlesHeaderText' + langSuffix);
        if (textType == "SEO") {
          this.seoService.setTitle(this.getString('seasonBundlesHeaderTitle' + langSuffix));
          this.seoService.setMetaDescription(this.getString('seasonBundlesHeaderText' + langSuffix));
          return;
        }
      }
    }

    if (this.listType == Global.IMDBTOP250) {
      if (textType == "HeaderTitle") return this.getString('imdbTop250HeaderTitle');
      if (textType == "HeaderText") return this.getString('imdbTop250HeaderText');
      if (textType == "SEO") {
        this.seoService.setTitle(this.getString('imdbTop250HeaderTitle'));
        this.seoService.setMetaDescription(this.getString('imdbTop250HeaderText'));
        return;
      }
    }

    if (this.listType == Global.PREORDER) {
      if (textType == "HeaderTitle") return this.getString('preorderHeaderTitle');
      if (textType == "HeaderText") return this.getString('preorderHeaderText');
      if (textType == "SEO") {
        this.seoService.setTitle(this.getString('preorderHeaderTitle'));
        this.seoService.setMetaDescription(this.getString('preorderHeaderText'));
        return;
      }
    }

    if (this.listType == Global.RECENTLYADDED) {

      let key = "recentlyAddedHeaderTitle";
      const mediaTypesVideo = [Global.MOVIES, Global.SEASONS];
      const mediaTypesMusic = [Global.MUSIC];
      const mediaTypesBooks = [Global.EBOOKS, Global.AUDIOBOOKS];

      if (mediaTypesVideo.includes(Global.getMediaTypeForSelector(mediaType))) {
        key = "newOnAppleTvTitle";
      }

      if (mediaTypesMusic.includes(Global.getMediaTypeForSelector(mediaType))) {
        key = "newOnAppleMusicTitle";
      }

      if (mediaTypesBooks.includes(Global.getMediaTypeForSelector(mediaType))) {
        key = "newOnAppleBooksTitle";
      }

      if (textType == "HeaderTitle") return StringHelper.format(this.getString(key), mediaTypeUpper);
      if (textType == "HeaderText") return this.getString('recentlyAddedHeaderText' + langSuffix);
      if (textType == "SEO") {
        this.seoService.setTitle(StringHelper.format(this.getString('recentlyAddedHeaderTitle'), mediaTypeUpper));
        this.seoService.setMetaDescription(this.getString('recentlyAddedHeaderText' + langSuffix));
        return;
      }
    }

    if (this.listType == Global.JUST_RELEASED) {
      if (textType == "HeaderTitle") return this.getString('justReleasedTitle');
      if (textType == "HeaderText") return this.getString('justReleasedDesc');
      if (textType == "SEO") {
        this.seoService.setTitle(this.getString('justReleasedTitle'));
        this.seoService.setMetaDescription(this.getString('justReleasedDesc'));
        return;
      }
    }

    if (this.listType == Global.VISION_PRO_APPS) {
      if (textType == "HeaderTitle") return this.getString('visionProAppsHeaderTitle');
      if (textType == "HeaderText") return this.getString('visionProAppsHeaderText');
      if (textType == "SEO") {
        this.seoService.setTitle(this.getString('visionProAppsHeaderTitle'));
        this.seoService.setMetaDescription(this.getString('visionProAppsHeaderText'));
        return;
      }
    }

    if (this.listType == Global.NOW_FREE) {
      if (mediaType == Global.APPS) {
        if (textType == "HeaderTitle") return this.getString('nowFreeAppsHeaderTitle');
        if (textType == "HeaderText") return this.getString('nowFreeAppsHeaderText');
        if (textType == "SEO") {
          this.seoService.setTitle(this.getString('nowFreeAppsHeaderTitle'));
          this.seoService.setMetaDescription(this.getString('nowFreeAppsHeaderText'));
          return;
        }
      }
      if (mediaType == Global.MACAPPS) {
        if (textType == "HeaderTitle") return this.getString('nowFreeMacAppsHeaderTitle');
        if (textType == "HeaderText") return this.getString('nowFreeMacAppsHeaderText');
        if (textType == "SEO") {
          this.seoService.setTitle(this.getString('nowFreeMacAppsHeaderTitle'));
          this.seoService.setMetaDescription(this.getString('nowFreeMacAppsHeaderText'));
          return;
        }
      }
    }

    if (this.listType == Global.BLACK_FRIDAY) {
      if (Global.getStore() == Global.ITUNES) {
        if (textType == "HeaderTitle") return this.getString('blackFridayHeaderTitleiTunes');
        if (textType == "HeaderText") return this.getString('blackFridayHeaderTextiTunes');
        if (textType == "SEO") {
          this.seoService.setTitle(this.getString('blackFridayHeadeTitleiTunes'));
          this.seoService.setMetaDescription(this.getString('blackFridayHeaderTextiTunes'));
          return;
        }
      }
      else if (Global.getStore() == Global.AMAZON) {
        if (textType == "HeaderTitle") return this.getString('blackFridayHeaderTitleAmazon');
        if (textType == "HeaderText") return this.getString('blackFridayHeaderTextAmazon');
        if (textType == "SEO") {
          this.seoService.setTitle(this.getString('blackFridayHeaderTitleAmazon'));
          this.seoService.setMetaDescription(this.getString('blackFridayHeaderTextAmazon'));
          return;
        }
      }
      else if (Global.getStore() == Global.VUDU) {
        if (textType == "HeaderTitle") return this.getString('blackFridayHeaderTitleVudu');
        if (textType == "HeaderText") return this.getString('blackFridayHeaderTextVudu');
        if (textType == "SEO") {
          this.seoService.setTitle(this.getString('blackFridayHeaderTitleVudu'));
          this.seoService.setMetaDescription(this.getString('blackFridayHeaderTextVudu'));
          return;
        }
      }
      else if (Global.getStore() == Global.GOOGLEPLAY) {
        if (textType == "HeaderTitle") return this.getString('blackFridayHeaderTitleGooglePlay');
        if (textType == "HeaderText") return this.getString('blackFridayHeaderTextGooglePlay');
        if (textType == "SEO") {
          this.seoService.setTitle(this.getString('blackFridayHeaderTitleGooglePlay'));
          this.seoService.setMetaDescription(this.getString('blackFridayHeaderTextGooglePlay'));
          return;
        }
      }
    }

    // FALLBACKS!

    if (textType == "HeaderTitle") return this.getString('genericHeaderTitle');
    if (textType == "HeaderText") return this.getString('genericHeaderText');
    if (textType == "SEO") {
      this.seoService.setTitle(this.getString('genericHeaderTitle'));
      this.seoService.setMetaDescription(this.getString('genericHeaderText'));
      return;
    }
  }

  closeSortPeriodNewFeatureBubble() {
    StorageHelper.getInstance().save(StorageHelper.keys.showSortPeriodNewFeatureBubble, "false");
  }

  closeHideFrenchTitlesNewFeaturePopup() {
    StorageHelper.getInstance().save(StorageHelper.keys.showHideFrenchTitlesNewFeaturePopup, "false");
  }

}
